import * as React from "react";
import type { SVGProps } from "react";
const SvgTrello = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7 7V6a1 1 0 0 0-1 1zm3 0h1a1 1 0 0 0-1-1zm0 9v1a1 1 0 0 0 1-1zm-3 0H6a1 1 0 0 0 1 1zm7-9V6a1 1 0 0 0-1 1zm3 0h1a1 1 0 0 0-1-1zm0 5v1a1 1 0 0 0 1-1zm-3 0h-1a1 1 0 0 0 1 1zM5 4h14V2H5zm14 0a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3zm1 1v14h2V5zm0 14a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3zm-1 1H5v2h14zM5 20a1 1 0 0 1-1-1H2a3 3 0 0 0 3 3zm-1-1V5H2v14zM4 5a1 1 0 0 1 1-1V2a3 3 0 0 0-3 3zm3 3h3V6H7zm2-1v9h2V7zm1 8H7v2h3zm-2 1V7H6v9zm6-8h3V6h-3zm2-1v5h2V7zm1 4h-3v2h3zm-2 1V7h-2v5z"
    />
  </svg>
);
export default SvgTrello;
